<template>
  <DashboardTabbedContentBox v-if="hasTabPagesAccessible" :gridHeight="640" large>
    <template v-slot:tablist>
      <Tab :first="index == 0" :tabid="`tab-tasktype-${taskType.id}`" v-for="(taskType, index) of taskTypeList" :key="taskType.id">
        <i :class="['tabbedbox-tab-icon', 'fas', getTaskTypeIcon(taskType)]"></i>
        <div class="tabbedbox-tab-info">
          <div class="tabbedbox-tab-title">{{taskType.name}}</div>
          <div class="tabbedbox-tab-subtitle">Task</div>
        </div>
      </Tab>
      <!--
        FUTURE OPTIONS
        -->
      <Tab tabid="tab-production" :first="testProduction" v-if="testProduction">
        <i class="far fa-tools"></i> Production
      </Tab>
      <!--
      <Tab tabid="tab-accounts">
        <i class="far fa-envelope-open-dollar"></i> Accounts
      </Tab>
      -->
    </template>

    <template v-slot:tabcontent>
      <TabPage :first="index == 0" :tabid="`tab-tasktype-${taskType.id}`" v-for="(taskType, index) of taskTypeList" :key="taskType.id" :class="{'tabpage-padding-0': taskType.isLocationTrackingEnabled}">
        <TaskLocationDashboardBox :taskTypeId="taskType.id" v-if="taskType.isLocationTrackingEnabled" />            
        <TaskDashboardBox :taskTypeId="taskType.id" v-if="!taskType.isLocationTrackingEnabled" />            
      </TabPage>

      <TabPage tabid="tab-production" :first="testProduction" v-if="testProduction">
        <ContentTitle>Production Capacity</ContentTitle>
        <ContentSubTitle>Capacity for production panel stages due today</ContentSubTitle>
        <div class="row no-gutters">
          <div class="col">
            <ContentTitle>Annealed Cutting</ContentTitle>
            <GaugeChart />
          </div>
            <div class="col">
            <ContentTitle>Laminated Cutting</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Manual Cutting</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Manual Arris</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Straight Line Polishing</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Mitre</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Waterjet</ContentTitle>
            <GaugeChart />
          </div>
          <div class="col">
            <ContentTitle>Toughening</ContentTitle>
            <GaugeChart />
          </div>
        </div>
      </TabPage>
      
    </template>
  </DashboardTabbedContentBox>
</template>

<style scoped>
.dashboard-analytics {
  height: 100%;
  min-height: 550px;
}
</style>

<script>
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'

import TaskDespatchMixin from '@/modules/tasks/mixins/taskDespatchMixin'
import TaskLocationDashboardBox from '@/modules/tasks/components/taskLocationDashboardBox'
import TaskDashboardBox from '@/modules/tasks/components/taskDashboardBox'

import GaugeChart from '@/modules/intelligence/components/gaugeChart'

export default {
  name: 'DashboardAnalyticsBox',
  mixins: [TaskDespatchMixin],
  components: {
    DashboardTabbedContentBox,
    TaskLocationDashboardBox,
    TaskDashboardBox,
    GaugeChart
  },
  props: {
    testProduction: Boolean // Testing production panel
  },
  data() {
    return {
      taskTypeList: []
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    hasTabPagesAccessible() {
      let requiredReadPermissions = [
        this.PermissionTypes.TaskPermissionTypes.task
      ]

      // Need at least 1 permission from the list to show the analytics box
      return requiredReadPermissions.some(permCode => this.userHasReadPermission(permCode)) && this.taskTypeList.length > 0
    },
    isDeliveryPageFirst() {
      if(this.testProduction)
        return false

      return this.userHasReadPermission(this.PermissionTypes.TaskPermissionTypes.task)
    }
  },
  methods: {
    requestData() {
      this.$apiService.tasksService.getTaskTypeList({ filter: { isActive: 1, isDashboardDisplayEnabled: 1 }})
      .then(response => {
        this.taskTypeList = response.data
      })
      .catch(err => {
        console.error(err)
      })
    }
  }
  
}
</script>